import { Chart as ChartJS, Plugin } from 'chart.js'

export const LABEL_PADDING_TOP = 42

const LABEL_LINE_HEIGHT = 13
const LABEL_OFFSET = 10

interface RecencyDataset {
  supplierCounts?: number[]
  borderColor?: string
}

export const recencyPointValueLabels: Plugin<'line'> = {
  id: 'recencyPointValueLabels',
  afterDatasetsDraw(chart) {
    const { ctx } = chart
    const dataset = chart.data.datasets[0] as RecencyDataset | undefined

    if (!dataset) {
      return
    }

    ctx.save()
    ctx.textAlign = 'center'
    ctx.textBaseline = 'bottom'

    chart.getDatasetMeta(0).data.forEach((element, index) => {
      const percentage = chart.data.datasets[0].data[index]
      const count = dataset.supplierCounts?.[index]

      if (typeof percentage !== 'number' || count === undefined) {
        return
      }

      ctx.fillStyle = dataset.borderColor ?? '#000'
      ctx.font = `700 11px ${ChartJS.defaults.font.family}`
      ctx.fillText(`${percentage}%`, element.x, element.y - LABEL_OFFSET - LABEL_LINE_HEIGHT)

      ctx.fillStyle = ChartJS.defaults.color as string
      ctx.font = `400 11px ${ChartJS.defaults.font.family}`
      ctx.fillText(count.toLocaleString(), element.x, element.y - LABEL_OFFSET)
    })

    ctx.restore()
  },
}
